import TextField from '@/components/TextField/TextField';
import styled from '@emotion/styled';
import { useFormContext } from 'react-hook-form';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
`;
const Title = styled.span`
    color: ${({ theme }) => theme.colors.secondary.main};
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
`;

export const TitleField = () => {
    const { register } = useFormContext();

    return (
        <Container>
            <Title id="campaign-title-field">Title</Title>
            <TextField
                multiline
                placeholder="Enter your title here"
                rows={3}
                inputProps={{
                    ...register('title'),
                    'data-hj-allow': '',
                }}
            />
        </Container>
    );
};
